import { AiOutlineThunderbolt } from "react-icons/ai";
import { TbTrendingUp } from 'react-icons/tb';
import { FaShieldAlt } from "react-icons/fa";
import { BsStars } from "react-icons/bs";


export default function WhyVideoRoyale() {
  const colorMap: Record<string, string> = {
    purple: '#a855f7',
    orange: '#f59e0b',
    cyan: '#06b6d4',
    yellow: '#f1ad37'
  };

  const benefits = [
    {
      title: 'Earn by predicting viral success',
      description: 'Use your intuition and data to predict if videos will hit their virality targets. Winners share the pot.',
      icon: <TbTrendingUp />,
      color: 'purple'
    },
    {
      title: 'Push videos to increase your chances',
      description: 'Share, promote, and influence the outcome. Your actions can help your prediction come true.',
      icon: <AiOutlineThunderbolt />,
      color: 'orange'
    },
    {
      title: 'Web3 native: USDC, transparency',
      description: 'USDC escrow ensures fairness. All payouts are transparent and on-chain.',
      icon: <FaShieldAlt />,
      color: 'cyan'
    },
    {
      title: 'Competitive and fun environment',
      description: 'VideoRoyale is a high-energy arena where data meets intuition. Every prediction is unique.',
      icon: <BsStars />,
      color: 'yellow'
    }
  ];

  const stats = [
    {
      title: 'Total volume',
      value: '$2.4M'

    },
    {
      title: 'Predictions made',
      value: '12,847'
    },
    {
      title: 'Battles resolved',
      value: '489'
    },
    {
      title: 'Active users',
      value: '8,234'
    }
  ];

  return (
    <section id="features" className="section why-video-royale">
      <div className="container">
        <div className="section-header text-center">
          <h1>Why VideoRoyale</h1>
          <p>The future of prediction markets is here</p>
        </div>

        <div className="why-video-royale-grid">
          {benefits.map((benefit, index) => {
            const colorHex = colorMap[benefit.color];
            return (
              <div
                key={index}
                className={`glass-card benefit-card benefit-${benefit.color}`}
              >
                <div
                  className="benefit-icon"
                  style={{
                    color: 'white',
                    background: `linear-gradient(135deg, ${colorHex}80, ${colorHex}40)`
                  }}
                >
                  {benefit.icon}
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            );
          })}
        </div>
        <div className="stats-flex">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card glass-card">
              <p className="stat-value">{stat.value}</p>
              <p>{stat.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
